import RiotControl from 'riotcontrol'
import logger from '../logger'
import extendedObservable from './base'
import api from '../api'
import AjaxUtils from '../utils/ajax-utils'



// ////////////////////////////////////////////////////////////////////////////////
// NOTE: This observable should be treated like a module for the orderObservable //
// no components should subscribe to this data directly but should instead       //
// subscribe to the orderObservable                                              //
// ////////////////////////////////////////////////////////////////////////////////


// //////////////////////
// Coupons Observable //
// //////////////////////

export function CouponsObservable() {
  const orderResourceKey = 'coupons'

  extendedObservable(this, 'couponsModel', [])

  const successHandler = (json, status, xhr) => {
    RiotControl.trigger('updateOrderResource', orderResourceKey, this.model)

    // update the order checksum
    const checksum = xhr.getResponseHeader('checksum')
    RiotControl.trigger('updateOrderChecksum', checksum)

    return json
  }

  const errorHandler = (xhr, status, errorThrown) => {
    logger(`Error: Failed to communicate with OP Service - ${errorThrown}`, 'error')()
    logger(`Status: ${status}`, 'error')()
    logger(xhr, 'error')()

    // If checksum is invalid
    if (AjaxUtils.checkForBadChecksum(xhr)) {
      AjaxUtils.handleChecksumMismatch()
    }

    if (AjaxUtils.checkForNoOrder(xhr)) {
      AjaxUtils.handleNoOrder()
    }


    // update the order checksum
    const checksum = xhr.getResponseHeader('checksum')
    RiotControl.trigger('updateOrderChecksum', checksum)

    return xhr
  }

  this.on('createCoupon', (data, cb, errorCb) => {
    api.coupons.post(data)
      .then(successHandler)
      .then(() => new Promise(resolve => RiotControl.trigger('auditOrder', () => resolve())))
      .then(() => new Promise((resolve) => {
        const mCoupon = this.orderModel.safeGet('coupons', []).filter(c => c.type === 'MANUAL')[0]
        if (mCoupon && mCoupon.disposition === 'Error') {
          return api.coupon.delete(mCoupon.name).then((json, status, xhr) => {
            this.model = this.model.filter(c => c.name !== mCoupon.name)
            return successHandler(json, status, xhr)
          }).then(() => resolve(mCoupon))
        }

        return resolve(mCoupon)
      }))
      .then(cb)
      .catch((xhr, status, errorThrown) => {
        errorHandler(xhr, status, errorThrown)
        if (typeof errorCb === 'function') {
          errorCb(errorThrown)
        }
      })
  })

  this.on('getCoupons', (cb) => {
    api.coupons.get()
      .then(successHandler)
      .then((coupons) => {
        this.model = coupons
        return successHandler(coupons)
      })
      .then(cb)
      .catch(errorHandler)
  })

  this.on('removeCoupon', (name, cb, errorCb) => {
    api.coupon.delete(name)
      .then(successHandler)
      .then(() => new Promise(resolve => RiotControl.trigger('auditOrder', order => resolve(order))))
      .then(cb)
      .catch((xhr, status, errorThrown) => {
        errorHandler(xhr, status, errorThrown)
        if (typeof errorCb === 'function') {
          errorCb(errorThrown)
        }
      })
  })
}
